export default "__VITE_ASSET__2a6288a2__"